import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <AboutSection />
        <FeaturesSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            '@id': 'https://hipobuyspread.click/#organization',
            'name': 'Hipobuy Spread',
            'url': 'https://hipobuyspread.click',
            'logo': 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/16c9e81c106f6a445869e4a45760203f.jpeg',
            'description': 'Independent spreadsheet research hub for smarter product discovery. Guides, comparisons, tutorials, and research resources for Hipobuy Spreadsheet users.',
            'sameAs': [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            '@id': 'https://hipobuyspread.click/#website',
            'url': 'https://hipobuyspread.click',
            'name': 'Hipobuy Spread',
            'description': 'The ultimate spreadsheet research hub for smarter product discovery. Independent guides, comparisons, tutorials, and research resources.',
            'publisher': {
              '@id': 'https://hipobuyspread.click/#organization',
            },
            'potentialAction': {
              '@type': 'SearchAction',
              'target': {
                '@type': 'EntryPoint',
                'urlTemplate': 'https://kaspreadsheet.com/search?q={search_term_string}',
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </div>
  );
}